import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import { useMemo, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { themeSettings } from './theme';
import { Helmet } from 'react-helmet';

// Layouts
import Layout from './components/Layout';

// Pages
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PricingPage from './pages/PricingPage';
import ConnectPage from './pages/ConnectPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

function App() {
  const [mode, setMode] = useState("dark");
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  // JSON-LD structured data for rich search results
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SOLVENDA",
    "url": "https://solvenda.org",
    "logo": "https://solvenda.org/logo.png",
    "description": "Modular ISP management platform: billing, customers, FreeRadius internet (SolvendaRadius), ZTE OLT management, fiscalization and online card payments (SolvendaConnect).",
    "sameAs": [
      "https://facebook.com/solvenda",
      "https://linkedin.com/company/solvenda"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+35569-209-8563",
      "contactType": "customer service",
      "email": "info@solvenda.org",
      "availableLanguage": ["English", "Albanian"]
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Tirana",
      "addressCountry": "Albania"
    },
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "EUR",
      "lowPrice": "15",
      "highPrice": "80",
      "offerCount": "8"
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
      <CssBaseline />
      <Routes>
        <Route element={<Layout mode={mode} setMode={setMode} />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          {/* Redirect any unknown routes to home page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App; 